import {
    helperGetCookie,
    helperSetCookie,
    helperSetCookieExpirationDate,
} from "../functions/cookiesHelpers";

export default class BrowserLangModal {
    constructor() {
        this.modal = document.querySelector(".jsBrowserLangModal");

        let browserLang = helperGetCookie("ig_browser_lang");
        const acceptLangModal = helperGetCookie("ig_accept_lang_modal");

        // Get browser lang if there is no cookie
        if (browserLang === undefined) {
            this.language = navigator.languages
                ? navigator.languages[0]
                : navigator.language || navigator.userLanguage;

            if (this.language.includes("-")) {
                this.language = this.language.substring(
                    0,
                    this.language.indexOf("-")
                );
            }

            helperSetCookie("ig_browser_lang", this.language, {
                expires: helperSetCookieExpirationDate(30),
            });

            browserLang = helperGetCookie("ig_browser_lang");
        }

        if (
            !(browserLang.localeCompare("pl") === 0) &&
            acceptLangModal === undefined
        ) {
            this.events();
        }
    }

    events() {
        this.modalForeignUser();

        this.modal.addEventListener("click", (e) => {
            this.closeModalLang();
        });
    }

    modalForeignUser() {
        this.modal.classList.remove("is-hidden");
        this.modal.style.display = "flex";
    }

    closeModalLang() {
        this.modal.classList.add("is-hidden");

        helperSetCookie("ig_accept_lang_modal", "1", {
            expires: helperSetCookieExpirationDate(30),
        });
    }
}
